import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ErrorCollectModule } from '@knz/assembly/error-collect';
import { KNZUtilModule } from '@knz/util';

import { FooterToolbarComponent } from './footer-toolbar.component';

const COMPONENTS = [FooterToolbarComponent];

@NgModule({
  imports: [CommonModule, ErrorCollectModule, KNZUtilModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class FooterToolbarModule {}
